import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMemo } from "react";
import { useNiveles } from "../../../../context/SuperAdmin/OASContexts/NivelesContext";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import { NivelesRow } from "./NivelesRow";

const NivelesTable = () => {
  const { niveles, setSelectedNiveles, selectedNiveles, searchText } =
    useNiveles();

  const selectAll = () => {
    setSelectedNiveles(filteredNiveles.map((nivel) => nivel.id_nivel));
  };

  // Manejar selección/deselección de un nivel
  const handleSelect = (id: string) => {
    setSelectedNiveles((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // Filtro de niveles por búsqueda
  const filteredNiveles = useMemo(() => {
    const normalizedSearch = searchText.toLowerCase().trim();
    return niveles.filter((u) =>
      u.nombre.toLowerCase().includes(normalizedSearch)
    );
  }, [niveles, searchText]);

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell sx={{ maxWidth: "100px", width: 50 }}>
              <Checkbox
                color="primary"
                checked={selectedNiveles.length > 0} // Check general
                onChange={(e) => {
                  if (e.target.checked) {
                    selectAll();
                  } else {
                    setSelectedNiveles([]);
                  }
                }}
                sx={{
                  color: "white", // Color del checkbox cuando no está seleccionado
                  "&.Mui-checked": {
                    color: "white", // Color del icono cuando está seleccionado
                  },
                  "& .MuiSvgIcon-root": {
                    border: "2px solid white", // Borde blanco alrededor del checkbox
                    borderRadius: "4px", // Bordes redondeados
                  },
                }}
              />
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              N°
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Nombre
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Fecha de creación
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Acciones
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredNiveles.length > 0 ? (
            filteredNiveles.map((item, index) => (
              <NivelesRow
                nivel={item}
                i={index + 1}
                key={item.id_nivel}
                handleSelect={handleSelect}
                isSelected={selectedNiveles.includes(item.id_nivel)}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NivelesTable;
